import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';
import { useAuth } from '../../../contexts/AuthContext';

const LoginForm = () => {
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.email) {
      newErrors.email = 'L\'indirizzo email è obbligatorio';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(formData?.email)) {
      newErrors.email = 'Inserisci un indirizzo email valido';
    }

    if (!formData?.password) {
      newErrors.password = 'La password è obbligatoria';
    } else if (formData?.password?.length < 6) {
      newErrors.password = 'La password deve contenere almeno 6 caratteri';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors?.[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleCheckboxChange = (e) => {
    setFormData(prev => ({
      ...prev,
      rememberMe: e?.target?.checked
    }));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    try {
      const { error } = await signIn(formData?.email, formData?.password);
      
      if (error) {
        setErrors({
          submit: error?.message || 'Credenziali non valide'
        });
      } else {
        navigate('/main-storefronts');
      }
    } catch (error) {
      setErrors({
        submit: 'Errore di rete. Riprova.'
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit} className="w-full space-y-6">
        <div>
          <Input
            type="email"
            name="email"
            label="Indirizzo Email"
            placeholder="esempio@email.it"
            value={formData?.email}
            onChange={handleInputChange}
            error={errors?.email}
            required
            disabled={isLoading}
          />
        </div>
        <div>
          <div className="relative">
            <Input
              type={showPassword ? 'text' : 'password'}
              name="password"
              label="Password"
              placeholder="Inserisci la tua password"
              value={formData?.password}
              onChange={handleInputChange}
              error={errors?.password}
              required
              disabled={isLoading}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-[38px] text-muted-foreground hover:text-foreground transition-smooth focus:outline-none"
              disabled={isLoading}
            >
              <Icon name={showPassword ? 'EyeOff' : 'Eye'} size={20} />
            </button>
          </div>
        </div>
        <div className="flex items-center justify-between">
          <Checkbox
            label="Ricordami"
            checked={formData?.rememberMe}
            onChange={handleCheckboxChange}
            disabled={isLoading}
          />
          <button
            type="button"
            onClick={() => navigate('/register')}
            className="text-sm text-primary hover:text-primary/80 transition-smooth focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3 rounded px-2 py-1"
            disabled={isLoading}
          >
            Password dimenticata?
          </button>
        </div>
        {errors?.submit && (
          <div className="p-4 rounded-lg bg-destructive/10 border border-destructive/20">
            <div className="flex items-start gap-3">
              <Icon name="AlertCircle" size={20} className="text-destructive flex-shrink-0 mt-0.5" />
              <p className="text-sm text-destructive">{errors?.submit}</p>
            </div>
          </div>
        )}
        <Button
          type="submit"
          variant="default"
          size="lg"
          fullWidth
          loading={isLoading}
          iconName="LogIn"
          iconPosition="right"
        >
          Accedi
        </Button>
      </form>

      <div className="mt-6 p-4 bg-muted/50 rounded-lg border border-border">
        <p className="text-sm font-semibold text-foreground mb-2">Credenziali Demo:</p>
        <div className="space-y-1 text-xs text-muted-foreground">
          <p><strong>Admin:</strong> admin@cliccami.net / Admin2026!</p>
          <p><strong>Negozio:</strong> negozio1@cliccami.net / Negozio2026!</p>
          <p><strong>Cliente:</strong> cliente1@example.com / Cliente2026!</p>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;